import { setValueInStorage } from "~/hooks/localStorageHelpers";
export const GetTargetDiscoverySetupKey = (spaceId: string, projectSlug: string | undefined) => {
    return projectSlug ? `Octopus.Project.${spaceId}.${projectSlug}.TargetDiscovery.Confirmed` : "";
};
export const ConfirmTargetDiscoverySetup = (spaceId: string, projectSlug: string | undefined) => {
    setValueInStorage(GetTargetDiscoverySetupKey(spaceId, projectSlug), "true");
};
